import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type FeedSlice = {
  feeds: WishamFeed[];
  hasMore: boolean;
  page: number;
  currentPopularItemIndex: number;
}

const initialState = {
  feeds: [],
  hasMore: false,
  page: 1,
  currentPopularItemIndex: 0
} as FeedSlice

export const feedSlice = createSlice({
  name: "feedSlice",
  initialState: initialState,
  reducers: {
    updateFeeds: (state, action: PayloadAction<WishamFeed[]>) => {
      state.feeds = structuredClone(action.payload).filter(feed => !!feed)
    },
    updateFeedHasMore: (state, action: PayloadAction<boolean>) => {
      state.hasMore = action.payload
    },
    increaseFeedPage: (state) => {
      state.page = state.page + 1
    },
    updateCurrentPopularItemIndex: (state, action: PayloadAction<number>) => {
      state.currentPopularItemIndex = action.payload
    },
    resetFeedPage: (state) => {
      state.page = initialState.page
    },
    resetFeedSlice: () => structuredClone(initialState)
  }
})

export const {
  updateFeeds,
  updateFeedHasMore,
  increaseFeedPage,
  updateCurrentPopularItemIndex,
  resetFeedPage,
  resetFeedSlice
} = feedSlice.actions

export default feedSlice.reducer
